import { doc, getDoc, serverTimestamp, updateDoc } from 'firebase/firestore';
import { db } from '../lib/firebase';

/** Campos comerciales editables. NO se exponen SOL / certificados / client_secret. */
const SAFE_FIELDS = [
  'razonSocial',
  'nombreComercial',
  'direccion',
  'departamento',
  'provincia',
  'distrito',
  'ubigueo',
  'telefono',
  'logo',
  'serieFactura',
  'serieBoleta',
  'serieNotaCredito',
  'serieNotaDebito',
  'serieGuia',
  'businessType',
  'activo',
];

export function sanitizeCompany(data) {
  const out = { id: data.id || data.ruc, ...data };
  // Ocultar secretos en UI
  delete out.sol_pass;
  delete out.sol_user;
  delete out.client_secret;
  delete out.client_id;
  delete out.certificado;
  if (data.sol_user) out.solUserConfigured = true;
  if (data.certificado) out.certificadoConfigured = true;
  return out;
}

export async function getCompany(ruc) {
  if (!ruc) throw new Error('RUC requerido');
  const snap = await getDoc(doc(db, 'company', ruc));
  if (!snap.exists()) throw new Error('Empresa no encontrada');
  return sanitizeCompany({ id: snap.id, ...snap.data() });
}

export async function updateCompany(ruc, data) {
  if (!ruc) throw new Error('RUC requerido');
  const payload = { updatedAt: serverTimestamp() };
  for (const key of SAFE_FIELDS) {
    if (data[key] !== undefined) payload[key] = data[key];
  }
  // No tocar creatorUid, ownerEmail, SOL ni certificados
  await updateDoc(doc(db, 'company', ruc), payload);
}

export function hasSolConfigured(company) {
  return !!(company?.solUserConfigured || company?.sol_user);
}

export function hasCertConfigured(company) {
  return !!(company?.certificadoConfigured || company?.certificado);
}
